export const SEND_LOGIN_REQUEST = 'sendLoginRequest';
export const SEND_JOIN_INVITE_REQUEST = 'sendJoinInviteRequest';
export const SEND_PRP_REQUEST = 'sendPRPRequest';
export const SEND_BRP_REQUEST = 'sendBRPRequest';
export const SEND_FORGOT_PASSWORD_REQUEST = 'sendForgotPasswordRequest';
export const SEND_RESET_PASSWORD_REQUEST = 'sendResetPasswordRequest';
export const REQUIRE_TWO_FACTOR = 'requireTwoFactor';
export const SEND_LOGIN_REQUEST_WITH_TWO_FACTOR = 'sendLoginRequestWithTwoFactor';
export const SEND_RESET_PASSWORD_REQUEST_WITH_TWO_FACTOR = 'sendResetPasswordRequestWithTwoFactor';
export const CLEAN_TWO_FACTOR_AUTH = 'cleanTwoFactorAuth';